import React, { useEffect, useState, useRef } from "react";
import "../../../assets/scss/home.scss";
import "../../../assets/scss/tests.scss";
import "flatpickr/dist/flatpickr.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import { useSelector } from "react-redux";
import Spinner from "../../../@core/components/spinner/Fallback-spinner";
import PagePagination from "../../../components/tables/pagination";
import Repository from "../../../configs/axios/repository";
import NotesTable from "../../../components/tables/notesTable";
import { useLocation, useHistory } from "react-router-dom";
import Modal from "react-modal";
import x_mark from "../../../assets/images/courses/group.svg";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { Row, Col } from "reactstrap";
import Swal from "sweetalert2";
import copy from "../../../assets/images/account/copy-regular.svg";
import validator from "validator";

const customStyles = {
    content: {
        top: "50%",
        left: "58%",
        right: "auto",
        bottom: "auto",
        transform: "translate(-50%, -50%)",
        background: "#F9FAFC 0% 0% no-repeat padding-box",
        padding: "20px 30px",
        width: "45%",
        zIndex: "9000",
        maxHeight: "600px",
    },
};

const CourseDetails = (props) => {
    const locationState = useLocation();
    const history = useHistory();
    const [modalIsOpen, setIsOpen] = React.useState(false);
    const role = useSelector((state) => state.layout.role);
    let canDoIt = false;

    const [studentsData, setStudentsData] = useState([]);
    const [loadingData, setLoadingData] = useState(true);
    const [loadingStudents, setLoadingStudents] = useState(false);
    const queryParameters = new URLSearchParams(window.location.search);
    const course_id = queryParameters.get("course_id");
    const [courseData, setCourseData] = useState([]);
    const [notesData, setNotesData] = useState([]);
    const [showData, setShowData] = useState(10);
    const [skipData, setSkipData] = useState(0);
    let courseName = locationState.state?.courseName;
    localStorage.setItem("isCreate", false);
    const [count, setCount] = useState();

    const getCourseById = async (skipTake) => {
        setLoadingData(false);
        const result = await Repository.findByEndPoint(
            `api/course/getCourseById/${course_id}`
        );

        if (result.data.success == true) {
            setCourseData(result.data.data);
            setCount(result.data.data?.notes.length);
            setNotesData(result.data.data?.notes);
        }
        setLoadingData(true);
    };
    const createNote = async () => {
        history.push({
            pathname: "/createNote",
            search: `course_id=${course_id}`,
            state: { courseName },
        });
    };
    function openModal() {
        setIsOpen(true);
    }

    function closeModal() {
        setIsOpen(false);
    }

    const sendInvate = async (val) => {
        setLoadingData(false);
        let newData = {
            email: val,
            course_id: course_id,
            course_name: courseName,
        };

        const response = await Repository.postRequest(
            `api/users/sendInvateEmail`,
            newData
        );
        if (response.data?.success === true) {
            closeModal();
            setLoadingData(true);
            Swal.fire({
                text: "Invite  has been sent to email.",
                icon: "success",
                confirmButtonColor: "#16285e",
            });
        }
        setLoadingData(true);
    };
    const getStudentsByCourseId = async () => {
        setLoadingStudents(false);

        const result = await Repository.findByEndPoint(
            `api/students/getStudentsByCourseId/${course_id}`
        );

        if (result.data.success == true) {
            setStudentsData(
                result.data.data.map((item) => {
                    return item.email;
                })
            );
            setCount(result.data.data.length);
        }
        setLoadingStudents(true);
    };
    useEffect(() => {
        getStudentsByCourseId();
    }, []);

    useEffect(() => {
        localStorage.setItem("course_id", course_id);
        getCourseById();
    }, []);

    return loadingData && loadingStudents ? (
        <div className="testBodyDiv homeSection">
            <div className="childSec mb-2 px-2">
                <div className="clidrenDivCompakt testH1">
                    <div className="mt-3 ">
                        <h1>{courseName} - Notes</h1>
                    </div>
                </div>
                {role != "instructor" ? (
                    ""
                ) : (
                    <div className="notesHeadButtonsDiv">
                        <div
                            className="createBtnDiv createBtnDiv1 createBtnDivForStudent"
                            onClick={() => {
                                history.push({
                                    pathname: "/courseStudents",
                                    search: `course_id=${course_id}`,
                                    state: { courseName },
                                });
                            }}
                        >
                            <span>Manage Students</span>
                        </div>
                        <div
                            className="createBtnDiv createBtnDivForStudent"
                            onClick={() => {
                                createNote();
                            }}
                        >
                            <span className="plus">+</span>
                            <span>NEW NOTE</span>
                        </div>
                    </div>
                )}
            </div>
            {notesData?.length > 0 ? (
                <div>
                    <NotesTable
                        notes={notesData}
                        course_id={course_id}
                        refreshTable={getCourseById}
                        setLoadingData={setLoadingData}
                        loadingData={loadingData}
                        canDoIt={canDoIt}
                        courseName={courseName}
                        fromCourse={true}
                    />

                    <PagePagination
                        setShow={setShowData}
                        count={count}
                        setSkip={setSkipData}
                        skip={skipData}
                        show={showData}
                    />
                </div>
            ) : (
                <div>
                    <h5 className="nodata">No data created yet.</h5>
                </div>
            )}
            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                style={customStyles}
                ariaHideApp={false}
                contentLabel="Example Modal"
            >
                <div className="showNotes">
                    <h2>Invite email</h2>
                    <img
                        src={x_mark}
                        onClick={closeModal}
                        className="closeModalImg"
                    />
                </div>
                <div>
                    <Formik
                        initialValues={{
                            email: "",
                        }}
                        validate={(values) => {
                            const errors = {};

                            if (!values.email) {
                                errors.email = "Email is required.";
                            }

                            return errors;
                        }}
                        onSubmit={(values) => {
                            const emailArray = values.email.split(/[,\s]+/);

                            // Remove empty strings from the array
                            const filteredEmailArray = emailArray.filter(
                                (email) => email.trim() !== ""
                            );

                            // Call your function with the array of email addresses
                            sendInvate(filteredEmailArray);
                            sendInvate(emailArray);
                        }}
                    >
                        {({ isSubmitting }) => (
                            <Form className="formikEvents">
                                <Row>
                                    <Col xl="12" md="12" sm="12">
                                        <Field
                                            className="formikInput"
                                            type="text"
                                            name="email"
                                            placeholder="Email*"
                                        />
                                        <ErrorMessage
                                            className="errorMessage"
                                            name="email"
                                            component="div"
                                        />
                                    </Col>
                                    <Col xl="12" md="12" sm="12">
                                        <div className="modalBtn">
                                            <button
                                                type="submit"
                                                className="btnOk"
                                            >
                                                Send
                                            </button>
                                            <button
                                                onClick={() => {
                                                    closeModal();
                                                }}
                                                className="btnCancel"
                                            >
                                                Cancel
                                            </button>
                                        </div>
                                    </Col>
                                </Row>
                            </Form>
                        )}
                    </Formik>
                </div>
            </Modal>
        </div>
    ) : (
        <Spinner spiner={true} />
    );
};

export default CourseDetails;
